import { SortDef, parseSorts } from '../AllTasksTab/helpers/parse'

export const getSort = (sorts: SortDef[]) => {
  const { normal, custom } = parseSorts(sorts)

  // Custom sort has priority
  if (custom.length > 0) {
    return `&custom_sort=${encodeURIComponent(custom[0])}`
  }

  // Normal sort
  if (normal.length > 0) {
    return `&sort=${encodeURIComponent(normal[0])}`
  }

  return ''
}
